import {apiBase} from './ApiBase'
import camelcaseKeys from "camelcase-keys"
import {Photo} from "@/entity/Photo";

export const getPhotos = async () => {
  const result = await apiBase.get(`/photos`)
  return camelcaseKeys(result.data.data, { deep: true }).map((p) => { return new Photo(p) })
}

export const getPhoto = async ({id}) => {
  const result = await apiBase.get(`/photos/${id}`)
  return new Photo(camelcaseKeys(result.data.data, { deep: true }))
}

export const addPhoto = async ({ photo }) => {
  const result = await apiBase.post(`/photos`, photo.export())
  return new Photo(camelcaseKeys(result.data.data, { deep: true }))
}

export const updatePhoto = async ({ photo }) => {
  const result = await apiBase.put(`/photos/${photo.id}`, photo.export())
  return new Photo(camelcaseKeys(result.data.data, { deep: true }))
}

export const deletePhoto = async ({ id }) => {
  await apiBase.delete(`/photos/${id}`)
  return 'ok'
}

export const getUserPhotos = async ({userId}) => {
  const result = await apiBase.get(`/photos/user/${userId}`, {})
  return camelcaseKeys(result.data.data, { deep: true }).map((p) => { return new Photo(p) })
}
